<input [(ngModel)]="filter" />
<button>Update</button>
<div class="wrapper">
  @for (asset of assets.slice(0, 100); track asset) {
    <div>
      @if (asset.t.toLowerCase().indexOf(filter) >= 0 || !filter) {
        <div>
          ...
          <!--   @todo or @deprecated    <p-chart type="line" [data]="asset.d"></p-chart> -->
        </div>
      }
    </div>
  }
</div>
